// extracted by mini-css-extract-plugin
export default {"grey_wrap":"ui_grey_wrap__uOGkY","grey_header":"ui_grey_header__sAZWq","title":"ui_title__gA6ME"};